import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import qs from 'qs';

import { post } from '@network/api';
import { useCheckoutStore } from '@stores/useCheckoutStore';

interface GenerateSessionPayload {
  type: string;
  service_id: string;
  customer_no: string;
  payment_method_id: number;
}

export interface GenerateSessionResponse {
  data?: {
    h2h_payment_info?: {
      web_redirect_url?: string;
    };
  };
}

export const useGenerateNewSession = (
  onSuccess?: (response: GenerateSessionResponse) => void
): UseMutationResult<GenerateSessionResponse, unknown, void> => {
  const location = useLocation();
  const { submittedCustomerNo } = useCheckoutStore();

  return useMutation({
    mutationFn: async () => {
      const { id, type, payment_method_id, service_id } = qs.parse(
        location.search,
        { ignoreQueryPrefix: true }
      ) as {
        id?: string;
        type?: string;
        payment_method_id?: string;
        service_id?: string;
      };

      if (!id) throw new Error('Invoice ID is missing');
      if (!type || !payment_method_id) {
        throw new Error(
          'Payment method is missing. Please select a payment method again.'
        );
      }

      const payload: GenerateSessionPayload = {
        type,
        service_id: service_id || '',
        customer_no: submittedCustomerNo || '',
        payment_method_id: Number(payment_method_id),
      };

      return post<GenerateSessionResponse>(
        `/checkout/v1/payment-method?invoice_number=${id}`,
        payload
      );
    },
    onSuccess: (response) => {
      onSuccess?.(response);
    },
  });
};
